import {
  getCheckpoints,
  getEpic,
  getEpicThroughId,
  getGanttChartData,
  getMilestoneHistory,
  getUserBoardEpic,
} from "../services/apiEpic";
import { hasQueryValue, useMappedQuery } from "./queryUtils";

export function useEpic(board_id) {
  return useMappedQuery({
    queryKey: ["epic", board_id],
    queryFn: () => getEpic(board_id),
    dataKey: "epics",
    enabled: hasQueryValue(board_id),
  });
}

export function useUserBoardEpic(id) {
  return useMappedQuery({
    queryKey: ["userepic", id],
    queryFn: () => getUserBoardEpic(id),
    dataKey: "epic",
  });
}

export function useEpicThroughId(epic_id) {
  return useMappedQuery({
    queryKey: ["epic_id", epic_id],
    queryFn: () => getEpicThroughId(epic_id),
    dataKey: "epics",
  });
}

export function useCheckpoints(epic_id) {
  return useMappedQuery({
    queryKey: ["checkpoints", epic_id],
    queryFn: () => getCheckpoints(epic_id),
    dataKey: "checkpoint",
  });
}

export function useMilestoneHistory(epic_id) {
  return useMappedQuery({
    queryKey: ["milestone_history", epic_id],
    queryFn: () => getMilestoneHistory(epic_id),
    dataKey: "history",
  });
}

export function useGanttChartData(epic_id) {
  return useMappedQuery({
    queryKey: ["gantt_chart_data", epic_id],
    queryFn: () => getGanttChartData(epic_id),
    dataKey: "ganttChartData",
  });
}
